<app-table *ngIf="roles.length">
  <app-table-headers>
    <app-table-header class="flex-double"></app-table-header>
    <app-table-header *ngFor="let role of roles">{{ role }}</app-table-header>
  </app-table-headers>

  <app-table-content>
    <app-table-row *ngFor="let permission of permissions; let i = index">
      <app-table-cell class="flex-double" [ngbTooltip]="permission">{{
        permission
      }}</app-table-cell>
      <ng-container *ngFor="let role of roles">
        <app-table-cell
          class="justify-content-center"
          [class.selected]="rolesWithPermissions[role].includes(permission)"
        >
          <div *ngIf="rolesWithPermissions[role].includes(permission)">X</div>
        </app-table-cell>
      </ng-container>
    </app-table-row>
  </app-table-content>
</app-table>
